import { render } from "./CompanyPolicyMain.vue?vue&type=template&id=d14307b8"
import script from "./CompanyPolicyMain.vue?vue&type=script&lang=ts"
export * from "./CompanyPolicyMain.vue?vue&type=script&lang=ts"
script.render = render

export default script